
import { db } from './firebaseConfig';
import { collection, addDoc } from "firebase/firestore";

const GarantiaEjectDB = async ({folio, id_cab_gar, id_cab_inst, item_id, item, categoria, medida, inicial, final, valor, userAdd, userMod, fechaAdd, fechaMod, emp_id }) => {

    return await addDoc(collection(db, 'bitacoragarantiaeject'), {
        folio: folio,
        id_cab_gar: id_cab_gar,
        id_cab_inst: id_cab_inst,
        item_id: item_id,
        item: item,
        categoria: categoria,
        medida: medida,
        inicial: inicial,
        final: final,
        valor: valor,
        useradd: userAdd,
        usermod: userMod,
        fechaadd: fechaAdd,
        fechamod: fechaMod,
        emp_id: emp_id        
    })
}

export default GarantiaEjectDB;